import { render, staticRenderFns } from "./SimpleChars.vue?vue&type=template&id=f52f3ca4"
import script from "./SimpleChars.vue?vue&type=script&lang=js"
export * from "./SimpleChars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports